var React = require('react');

function Cw (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("path",{"id":"b","d":"M0-1l.2.7H1L.3 0l.2.7L0 .4l-.6.4.2-.7-.5-.4h.7z","key":0}),React.createElement("clipPath",{"id":"a","key":1},React.createElement("path",{"fillOpacity":".7","d":"M0 0h682.7v512H0z"}))]),React.createElement("g",{"clipPath":"url(#a)","transform":"scale(.94)","key":1},[React.createElement("path",{"fill":"#002b7f","d":"M0 0h768v512H0z","key":0}),React.createElement("path",{"fill":"#f9e814","d":"M0 320h768v64H0z","key":1}),React.createElement("use",{"width":"13500","height":"9000","x":"2","y":"2","fill":"#fff","transform":"scale(42.67)","xlinkHref":"#b","key":2}),React.createElement("use",{"width":"13500","height":"9000","x":"3","y":"3","fill":"#fff","transform":"scale(56.9)","xlinkHref":"#b","key":3})])]);
}

Cw.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Cw;

Cw.default = Cw;
